module.exports = __webpack_public_path__ + "static/img/chart_1.ceed9854.svg";